import {BaseApiResponseModel} from "./base-api-response-model";
import {BaseApiRequestModel} from "./base-api-request-model";
import {BaseDomainModel} from "./base-domain-model";

export class BaseDomainDataSource extends BaseDomainModel {
  requestedUpdateId: number;
  lastUpdateId: Number;
  ttl: Number;
  delta: Promise<BaseApiResponseModel>;
  request: BaseApiRequestModel;

  constructor(model: BaseApiResponseModel) {
    super(model);

    this.requestedUpdateId = model.requestedUpdateId;
    this.lastUpdateId = model.lastUpdateId;
    this.ttl = model.ttl;
    this.request = model.request;
  }

  get isDelta(){
    return !!this.requestedUpdateId && this.requestedUpdateId !== -1;
  }

  update(model: BaseDomainDataSource){

  }
}
